

































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Table from '@shared/components/tables/table.vue';
import DisplayFieldBadge from '@shared/components/displays/display-field-badge/display-field-badge.vue';
import DisplayContactLink from '@shared/components/displays/display-contact-link/display-contact-link.vue';
import DisplayFieldCode from '@shared/components/displays/display-field-code/display-field-code.vue';
import {
  AccountingReportSession,
  AccountingReportSessionQueryParams,
} from '@accounting/interfaces/accounting-reports';
import { BPCTableField } from '@shared/interfaces/bpc-table-interface';
import {
  accountingReportDisplayFields,
  accountingReportSessionTableFields,
  filters,
} from '@/config/accounting_reports';
import TableFooterPagination from '@shared/layouts/wrappers/table/table-footer-pagination.vue';
import PaginationInterface from '@core/interfaces/pagination-interface';
import OrderingInterface from '@core/interfaces/ordering-interface';
import { DateRangeInterface, SelectOptionInterface } from '@shared/interfaces/inputs';
import TableWrapper from '@shared/layouts/wrappers/table/table-wrapper.vue';
import SearchInput from '@shared/components/forms/inputs/search-input.vue';
import MultiSelect from '@shared/components/forms/inputs/multi-select/multi-select.vue';
import DateRange from '@shared/components/forms/inputs/date-range/date-range.vue';
import { isNull } from 'lodash';
import BpcContentWrapper from '@shared/layouts/wrappers/content-wrapper.vue';
import BcReportSessionDetails from '@accounting/components/details/report-session-details/report-session-details.vue';
import AsyncExportModal from '@shared/components/modals/export-modal/async-export-modal.vue';
import DrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
import ModulesHelper from '@core/services/modules.helper';

@Component({
  name: 'bc-accounting-report-session-table',
  components: {
    'bpc-async-export-modal': AsyncExportModal,
    'bc-report-session-details': BcReportSessionDetails,
    'bc-content-wrapper': BpcContentWrapper,
    'bc-search-input': SearchInput,
    'bc-table-wrapper': TableWrapper,
    'bc-multi-select': MultiSelect,
    'bc-date-range': DateRange,
    'bc-table': Table,
    'bc-table-footer-pagination': TableFooterPagination,
    'bc-display-field-badge': DisplayFieldBadge,
    'bc-display-contact-link': DisplayContactLink,
    'bc-display-code': DisplayFieldCode,
    'bc-drawer-modal': DrawerModal,
  },
})
export default class AccountingReportSessionTable extends Vue {
  // PROPS
  @Prop({ type: String }) readonly actionsPortalTarget: string;
  @Prop({ type: Boolean, default: false }) readonly hideCheckColumn: boolean;
  @Prop({ type: Boolean, default: true }) readonly showFilters: boolean;
  @Prop({ type: Boolean, default: true }) readonly showOrdering: boolean;
  @Prop({ type: Boolean, default: true }) readonly showPagination: boolean;
  @Prop({ type: Boolean, default: true }) readonly showSearchFilter: boolean;
  @Prop({ type: Boolean, default: true }) readonly showPeriodFilter: boolean;
  @Prop({ type: Boolean, default: true }) readonly showOriginFilter: boolean;
  @Prop({ type: Boolean, default: true }) readonly showProductTypeFilter: boolean;
  @Prop({ type: String }) readonly orderBy: string;
  @Prop({ type: String }) readonly orderDirection: string;
  @Prop({ type: Boolean }) readonly withUrlParams: boolean;
  @Prop({ type: Object }) readonly initialFilters: Partial<AccountingReportSessionQueryParams>;

  // DATA
  // Table items & options
  loading: boolean = false;
  pagination: PaginationInterface = {
    current_page: 1,
    last_page: 1,
    per_page: 15,
    from: 0,
    to: 0,
    total: 0,
  };
  pageOptions: number[] = [5, 10, 15, 20, 50, 100, 200];
  ordering: OrderingInterface = {
    order_by: 'date',
    order_direction: 'desc',
  };
  orderByOptions: SelectOptionInterface[] = [
    {
      text: this.$t('global.accounting_reports.ordering.code.label').toString(),
      value: 'code',
    },
    {
      text: this.$t('global.accounting_reports.ordering.date.label').toString(),
      value: 'date',
    },
  ];
  items: AccountingReportSession[] = [];

  checkedAllItems: boolean = false;
  selectedSession: AccountingReportSession = null;
  showSessionReport: boolean = false;
  showReportModal: boolean = false;

  // Filters
  submittedSearch: string = '';
  selectedPeriod: string = null;
  selectedOrigin: string | string[] | undefined = [];
  selectedProductType: string | string[] | undefined = [];
  selectedDateRange: DateRangeInterface = {
    start_date: null,
    end_date: null,
  };

  // COMPUTED
  // COMPUTED PROPERTIES
  get exportPath(): string {
    return this.$bpcApiRouteHelper.getApiPath('accounting-reports/sessions/report/export');
  }

  get downloadPath(): string {
    return this.$bpcApiRouteHelper.getApiPath('accounting-reports/sessions/report/download');
  }

  get filtersToExport(): object {
    return {
      productType: this.selectedProductType,
      origin: this.selectedOrigin,
      period: this.selectedPeriod,
      startDate: this.selectedStartDate,
      endDate: this.selectedEndDate,
      search: this.submittedSearch,
      orderBy: this.ordering.order_by,
      orderDirection: this.ordering.order_direction,
    };
  }

  get showDateRangeFilter(): boolean {
    return this.selectedPeriod === 'custom';
  }

  get selectedStartDate(): string {
    return this.selectedDateRange.start_date;
  }

  get selectedEndDate(): string {
    return this.selectedDateRange.end_date;
  }
  get searchFilterPlaceholder(): string {
    return this.$t('global.table.filter.search').toString();
  }

  get periodFilterPlaceholder(): string {
    return this.$t(`${filters?.period?.placeholder}`).toString();
  }

  get originFilterPlaceholder(): string {
    return this.$t(`${filters?.origin?.placeholder}`).toString();
  }

  get productTypeFilterPlaceholder(): string {
    return this.$t(`${filters?.productType?.placeholder}`).toString();
  }
  // Filters options
  get periodFilterOptions(): SelectOptionInterface[] {
    return filters?.period?.options || [];
  }

  get originFilterOptions(): SelectOptionInterface[] {
    return (
      filters?.origin?.options.filter(item => {
        if (
          item.value !== 'pos_sales' ||
          (item.value === 'pos_sales' &&
            this.$modulesService.hasModuleActivated(ModulesHelper.POS_MODULE_NAME))
        ) {
          return item;
        }
      }) || []
    );
  }

  get productTypeFilterOptions(): SelectOptionInterface[] {
    return filters?.productType?.options || [];
  }
  get tableFields(): BPCTableField[] {
    return accountingReportSessionTableFields || [];
  }
  get displayConfig() {
    return accountingReportDisplayFields;
  }
  get changeDetectorStr(): string {
    return [
      this.submittedSearch,
      this.selectedPeriod,
      this.selectedOrigin,
      this.selectedProductType,
      this.selectedStartDate,
      this.selectedEndDate,
      this.pagination.per_page,
      this.pagination.current_page,
      this.ordering.order_by,
      this.ordering.order_direction,
    ].join('--');
  }

  get checkedItems() {
    return (
      this.items
        ?.filter(item => item.checked)
        ?.map(item => {
          return { id: item.id, origin: item.origin };
        }) || []
    );
  }

  get selectionCount(): number {
    return (this.checkedItems || []).length;
  }

  get totalItems(): number {
    return this.pagination?.total || 0;
  }

  // METHODS
  openAsyncReportModal() {
    this.showReportModal = true;
  }

  closeAsyncReportConfirmModal() {
    this.showReportModal = false;
  }

  clickOnReload(): void {
    this.getItemsIfStopChanging();
  }

  closeSessionDetailsModal(): void {
    this.showSessionReport = false;
  }

  onCheckAll(val: boolean) {
    this.checkedAllItems = val;
  }

  clickOnShow(data) {
    this.selectedSession = data.item;
    this.showSessionReport = true;
  }

  clickOnChangeOrderDirection(direction): void {
    this.ordering.order_direction = direction;
  }

  getQueryParams(): AccountingReportSessionQueryParams {
    return {
      productType: this.selectedProductType,
      origin: this.selectedOrigin,
      period: this.selectedPeriod,
      startDate: this.selectedStartDate,
      endDate: this.selectedEndDate,
      search: this.submittedSearch,
      orderBy: this.ordering.order_by,
      orderDirection: this.ordering.order_direction,
      perPage: this.pagination.per_page,
      page: this.pagination.current_page,
    };
  }

  getUlrParams() {
    const urlQueryParams = JSON.parse(JSON.stringify(this.$route.query), (k, v) => {
      console.log(v);
      if (!isNaN(v) && !isNull(v)) {
        return parseInt(v);
      }
      return v;
    });
    return {
      ...urlQueryParams,
    };
  }

  setUrlParams(params) {
    if (this.withUrlParams) {
      this.$router.push({ query: params }).catch(e => {
        return null;
      });
    }
  }

  async getItems() {
    this.loading = true;
    this.checkedAllItems = false;
    const params = this.getQueryParams();
    const baseUrl = this.$bpcApiRouteHelper.getEntityPath('accounting-report');
    const result = await this.$bpcApi.get(`${baseUrl}/sessions`, { params: params }).toPromise();
    this.items = result.data;
    this.loading = false;
    this.pagination = result.meta;
    this.setUrlParams(params);
  }

  getItemsIfStopChanging() {
    const changeStr = this.changeDetectorStr;
    setTimeout(() => {
      if (changeStr === this.changeDetectorStr) {
        this.getItems();
      }
    }, 300);
  }

  initializeFiltersFromProperties() {
    if (this.initialFilters) {
      this.selectedProductType = this.initialFilters?.productType || [];
      this.selectedOrigin = this.initialFilters?.origin || [];
      this.selectedPeriod = this.initialFilters?.period;
      this.selectedDateRange.start_date = this.initialFilters?.startDate;
      this.selectedDateRange.end_date = this.initialFilters?.endDate;
    }
  }

  initializeValuesFromUrlParams() {
    if (this.withUrlParams) {
      const urlParams = this.getUlrParams();

      if (!this.selectedProductType) {
        this.selectedProductType = urlParams?.productType;
      }
      if (!this.selectedOrigin?.length) {
        if (urlParams?.origin) {
          if (Array.isArray(urlParams.origin)) {
            this.selectedOrigin = urlParams.origin;
          } else {
            this.selectedOrigin = [urlParams.origin];
          }
        } else {
          this.selectedOrigin = [];
        }
      }

      if (!this.selectedPeriod) {
        this.selectedPeriod = urlParams?.period;
      }
      if (!this.selectedStartDate) {
        this.selectedDateRange.start_date = urlParams?.startDate;
      }
      if (!this.selectedEndDate) {
        this.selectedDateRange.end_date = urlParams?.endDate;
      }
      if (!this.submittedSearch) {
        this.submittedSearch = urlParams?.search || '';
      }
      if (!this.ordering.order_by) {
        this.ordering.order_by = urlParams?.orderBy || 'date';
      }
      if (!this.ordering.order_direction) {
        this.ordering.order_direction = urlParams?.orderDirection || 'desc';
      }
      if (!this.pagination.per_page) {
        this.pagination.per_page = urlParams?.perPage || 15;
      }
      if (!this.pagination.current_page) {
        this.pagination.current_page = urlParams?.page || 1;
      }
      console.log('QUERY PARAMS', urlParams);
    }
  }

  initializeOrderingFromProperties() {
    if (this.orderBy) {
      this.ordering.order_by = this.orderBy;
    }

    if (this.orderDirection) {
      this.ordering.order_direction = this.orderDirection;
    }
  }

  // LIFECYCLE
  mounted() {
    this.initializeFiltersFromProperties();
    this.initializeOrderingFromProperties();
    this.initializeValuesFromUrlParams();
    this.getItemsIfStopChanging();
  }

  @Watch('changeDetectorStr')
  onChangeDetectorStr() {
    this.getItemsIfStopChanging();
  }
}
